import {
    Directive,
    ElementRef
} from '@angular/core';

/**
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
    selector: '[ShowLoginPassword]' // Attribute selector
})

export default class ShowLoginPasswordDirective {
    private eyeIcon;
    private passwordInput;
    constructor(private el: ElementRef) {

    }

    ngOnInit() {
        if (this.el && this.el.nativeElement && this.el.nativeElement.parentElement) {
            this.passwordInput = this.el.nativeElement;
            this.eyeIcon = this.passwordInput.parentElement.querySelector("ion-icon");
            if (this.eyeIcon) {
                this.eyeIcon.style = 'cursor: pointer';
                this.eyeIcon.addEventListener('click', (event) => {

                    if (this.passwordInput.type === 'password') {
                        this.passwordInput.type = 'text';
                        this.eyeIcon.name = 'eye-off-outline';
                    } else {
                        this.passwordInput.type = 'password';
                        this.eyeIcon.name = 'eye-outline';
                    }
                });
            }
        }
    }

}

/*
    Directive class should be exported as ExportedClass
*/
export {
    ShowLoginPasswordDirective as ExportedClass
};